// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  margin-left: 33px;
  margin-right: 30px;
  padding-top: 40px;
  padding-bottom: 15px;
  font-size: 11px;
  color: #6e6d6a;
}`, "",{"version":3,"sources":["webpack://./src/app/common/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;AACD","sourcesContent":[".footer {\n\tmargin-left: 33px;\n\tmargin-right: 30px;\n\tpadding-top: 40px;\n\tpadding-bottom: 15px;\n\tfont-size: 11px;\n\tcolor: #6e6d6a;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
